
function integrationConstants() {
    return {
        LOCATION: {
            merchantCreation: {
                label: 'merchantCreation',
                value: '/mastercard/merchant/registration'
            },
            merchantAdmin: {
                label: 'merchantAdmin',
                value: '/merchant/settings/integration'
            },
            outletCreation: {
                label: 'outletCreation',
                value: '/merchant/formOutlet'
            },
            outletAdmin: {
                label: 'outletAdmin',
                value: '/outlet/settings/integration'
            }
        },
        INTEGRATION_TYPE: {
            FULFILLMENT: {
                value: 'fulfillment',
                label: 'Qkr Fulfillment app'
            },
            POS: {
                value: 'pos',
                label: 'POS'
            },
            CHARITY: {
                value: 'charity',
                label: 'Charity'
            }
        },
        POS_TYPE: {
            Micros: 'Micros',
            Comtrex: 'Comtrex',
            Paymentez: 'Paymentez',
            Eunoia: 'Eunoia',
            Quadranet: 'Quadranet',
            Demo: 'Demo',
            Omnivore: 'Omnivore',
            IBS: 'IBS',
            Pilot: 'Pilot',
            Ncr: 'Ncr',
            Zonal: 'Zonal'
        },
        POS_FEATURE: {
            PAY_AT_TABLE: 'payAtTable',
            BAR_TAB: 'barTab',
            COLLECTION: 'collection'
        },
        POS_SUB_FEATURE: {
            BAR_AND_PAT: 'barAndPat'
        },
        MERCHANT_PROPS: {
            ORDER_AHEAD_ENABLED: 'orderAheadEnabled',
            ORDER_AT_TABLE_MENU_SYNC: 'orderAtTableMenuSync'
        },
        VIEW_SETTINGS: {
            RADIO_YES: {
                label: 'On', value: true
            },
            RADIO_NO: {
                label: 'Off', value: false
            }
        }
    };
}
angular.module('qkr.integration.settings')
    .constant('integrationConstant', integrationConstants());



// WEBPACK FOOTER //
// ./src/integration-settings/constants/integration.constant.js